import React from "react";

const ProductItemVariant = (props) => {
	const { isSelected, variant, isAll, product, noVariants } = props;
	return (
		<div 
			className={"selection" + (isSelected ? " selected" : "")} 
			onClick={() => props.variantClicked(isAll ? product : variant, isAll ? 'product' : 'variant', noVariants)}
		>
			{props.noVariants && isAll 
			? <div className="txt">Select Product</div>
			: <div className="txt">{isAll ? 'Any Variant' : variant.sku}</div>}
			<span className="icon-star-full" />
		</div>
	)
}

export default ProductItemVariant



// WEBPACK FOOTER //
// ./src/components/admin/products/product-search/ProductItemVariant.js